import { BasicTrackingEvent } from "./BasicTrackingEvent";

import { TrackingEventIds } from "./constants/TrackingEventIds";

export class ClientLoadTrackingEvent extends BasicTrackingEvent {
    public gameId: number;
    public networkId: number;
    public distributorId: string;
    public versionDate: string;
    public cid: string;
    public websiteId: string;
    public accountId: string;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};
        vars.var_1 = this.distributorId;
        vars.var_2 = this.versionDate;
        vars.var_3 = this.cid;
        vars.var_4 = this.websiteId;
        vars.var_5 = this.accountId;
        vars.var_data = this.referrer;
        vars.eventId = TrackingEventIds.CLIENT_LOAD;
        vars.gameId = this.gameId;
        vars.networkId = this.networkId;
        return vars;
    }
}
